import { render, staticRenderFns } from "./website.vue?vue&type=template&id=2f421cf7"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports